var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.391,
    height: 31.859,
    viewBox: "0 0 26.391 31.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(-203.479 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "last-01",
    transform: "translate(203.479 95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M473.223,385.218,475,382.059a.482.482,0,0,0-.421-.719H457.995a.482.482,0,0,0-.421.722l4.774,8.341,9.147,15.793a.482.482,0,0,0,.827.012l2.723-4.411a.242.242,0,0,0,0-.254l-2.264-3.632a.241.241,0,0,0-.421.02l-.178.356a.241.241,0,0,1-.424.013l-6.991-12.15a.482.482,0,0,1,.421-.723l7.614.036A.482.482,0,0,0,473.223,385.218Z",
    transform: "translate(-457.51 -374.577)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M621.168,322.706l6.4-10.786h4.591l-11,19.046a.241.241,0,0,1-.417,0l-5.89-10.236a.241.241,0,0,1,.211-.362h4.218a.241.241,0,0,1,.211.122l1.256,2.211a.241.241,0,0,0,.414,0Z",
    transform: "translate(-606.545 -308.812)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M819.538,255.955l-1.546-.875a.241.241,0,0,1,.048-.44l5.72-1.753a.241.241,0,0,1,.306.18l1.219,5.682a.241.241,0,0,1-.354.26l-5.264-2.981",
    transform: "translate(-798.9 -252.876)",
    fill: "#64b5f6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.946e06fc78d684660c055580eb7c48c3.svg";
export { ForwardRef as ReactComponent };